<template>
    <div>
        <div class="main-testimonials__list">
            <transition-group name="fade">
                <article class="main-testimonials__item" v-for="item in testimonials" :key="item.title">
                    <header>
                        <div class="img"><img :src="item.photo" alt=""></div>
                        <h3 class="name">{{item.title}}</h3>
                        <div class="social">
                            <a :href="sn.url" :target="sn.target" v-for="sn in item.socials">
                                <svg class="icon" :class="sn.icon"><use :xlink:href="'/images/svg-symbols.svg#' + sn.icon"></use></svg>
                            </a>
                        </div>
                    </header>
                    <div>
                        <div v-html="item.text"></div>
                    </div>
                </article>
            </transition-group>
        </div>
        <transition name="fade" :duration="350">
            <slot>
                <div class="more-delimiter" v-show="testimonials.length < total">
                    <button class="button-pill" :class="{loading:isLoading}" v-on:click="getTestimonials()">Смотреть еще</button>
                </div>
            </slot>           
        </transition>
    </div>
</template>

<script>
    export default {
        props: ['parent', 'size'],
        data: function () {
            return {
                testimonials: [],
                currentPage: 0,
                total: 0,
                isLoading: false
            };
        },
        methods: {
            getTestimonials() {
                var vm = this;
                vm.isLoading = true;
                $.getJSON("/umbraco/Surface/Testimonials/GetTestimonials",
                    {
                        parent: this.parent,
                        page: this.currentPage,
                        size: this.size
                    })
                    .done(function (data) {
                        vm.testimonials = vm.testimonials.concat(data.Testimonials);
                        vm.currentPage++;
                        vm.total = data.Total;
                        vm.isLoading = false;
                    })
                    .fail(function () {
                        console.log('fail');
                        vm.isLoading = false;
                    });
            }
        },
        mounted: function () {
            this.getTestimonials();
        }
    }
</script>